import { AxiosInstance } from 'axios';

import { IUserMarkets } from 'src/services/contexts/markets/MarketContext';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => () => {
  return cancellable<IUserMarkets>(
    (cancelOptions: any) => api.get(url, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/user/profile.ts